import React, { useState, useEffect, useContext} from 'react'
import { DataContext } from './ContextProvider'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import PropertyFilter from './PropertyFilter';
import Loading from './Loading';

const Hero = () => {
  const [hero, setHero] = useState([])
  const [heroIndex, setHeroIndex] = useState(0)
  const {
    getDocs,
    collection,
    db
  } = useContext(DataContext)

  const heroRef = collection(db, "hero")

  useEffect(() => {
    const heroData = async () => {
      try{
        const data = await getDocs(heroRef)
        setHero(data.docs.map(doc => {
          return {
            ...doc.data(),
            id: doc.id
          }
        }))
      }catch(error){
        console.log(error.message)
      }
    }

    heroData()

    return () => heroData()
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setHeroIndex(prevIndex => (prevIndex + 1) % hero.length);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [hero]);

  const addIndex = () => {
    setHeroIndex(prevIndex => {
      return prevIndex === hero.length -1 ? 0 : prevIndex + 1
    })
  }

  const minusIndex = () => {
    setHeroIndex(prevIndex => {
      return prevIndex === 0 ? hero.length - 1 : prevIndex -1
    })
  }

  return (
    <section className="hero-section">
      <div className="hero-container">

        <div className="hero-btn-container">
          <button className="prev-btn hero-btn" onClick={minusIndex} aria-label="Previous Slide"><FiChevronLeft/> </button>
          <button className="next-btn hero-btn" onClick={addIndex} aria-label="Next Slide"><FiChevronRight/></button>
        </div>

        {hero.length ?  <div className="hero-wrapper">
          

          <div className="hero-image-container">
            <img src={hero[heroIndex].image} className="hero-image" alt="real-estate" />
          </div>

          <div className="hero-sub-container">
          <div className="hero-title-container">
            <h2 className="hero-title">{hero[heroIndex].title}</h2>
          </div>

          <div className="hero-description-container">
            <p className="hero-description">{hero[heroIndex].description}</p>
          </div>
          </div>
          </div>

          :
          
          <Loading />
        }
      </div>

      <div className="filter-container">
        <h3 className="filter-head">Find Your Home</h3>
        <PropertyFilter/>
      </div>
    </section>
  )
}

export default Hero
